
import { useEffect, useState } from 'react';
import { createClient } from '@supabase/supabase-js';
import { useNavigate } from 'react-router-dom';

const supabase = createClient(
  import.meta.env.VITE_PUBLIC_SUPABASE_URL,
  import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY
);

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const navigate = useNavigate(); // use React Router for navigation
  const [checking, setChecking] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  // Helper to navigate safely
  const safeNavigate = (path: string) => {
    try {
      navigate(path);
    } catch (err) {
      console.error('Navigation error:', err);
    }
  };

  const checkSession = async () => {
    try {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) {
        safeNavigate('/admin/login');
        return;
      }
      setAuthenticated(true);
    } catch (error) {
      console.error('Error checking session:', error);
      safeNavigate('/admin/login');
    } finally {
      setChecking(false);
    }
  };

  useEffect(() => {
    checkSession();

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      if (!session) {
        setAuthenticated(false);
        safeNavigate('/admin/login');
      } else {
        setAuthenticated(true);
      }
    });

    return () => {
      subscription.unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (checking) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center" dir="rtl">
        <div className="text-center">
          <div className="w-16 h-16 bg-[#B8935E]/10 rounded-full flex items-center justify-center mx-auto mb-4">
            <i className="ri-loader-4-line text-3xl text-[#B8935E] animate-spin"></i>
          </div>
          <p className="text-gray-600 font-medium">جاري التحقق من الصلاحيات...</p>
        </div>
      </div>
    );
  }

  if (!authenticated) {
    return null;
  }

  return <>{children}</>;
}
